import React from 'react';

const Hero: React.FC = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center gradient-bg overflow-hidden pt-24">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div 
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}
        ></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Floating geometric shapes */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-blue-400/20 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute top-40 right-20 w-32 h-32 bg-blue-300/20 rounded-full blur-xl animate-pulse delay-1000"></div>
        <div className="absolute bottom-40 left-1/4 w-24 h-24 bg-blue-500/20 rounded-full blur-xl animate-pulse delay-2000"></div>
        <div className="absolute bottom-20 right-1/3 w-16 h-16 bg-blue-600/20 rounded-full blur-xl animate-pulse delay-3000"></div>
        
        {/* Tech icons floating */}
        <div className="absolute top-32 right-1/4 text-blue-300/30 text-6xl animate-bounce delay-500">🛡️</div>
        <div className="absolute bottom-32 left-1/3 text-blue-400/30 text-5xl animate-bounce delay-1000">⚡</div>
        <div className="absolute top-1/2 right-10 text-blue-300/30 text-4xl animate-bounce delay-1500">🌐</div>
        <div className="absolute bottom-1/3 left-10 text-blue-400/30 text-5xl animate-bounce delay-2000">💻</div>
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
          {/* Main Heading */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight">
            <span className="block bg-gradient-to-r from-blue-400 via-napa-blue-500 to-napa-blue-700 bg-clip-text text-transparent mb-3">
              Napa Corporation
            </span>
            <span className="block text-xl sm:text-2xl lg:text-3xl font-light text-white">
              Solutions & Services
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-blue-100 mb-8 max-w-3xl mx-auto lg:mx-0 leading-relaxed">
            ให้บริการโซลูชันครบวงจรสำหรับงานราชการ โรงแรม โรงงาน สถานศึกษา 
            และองค์กรต่างๆ ด้วยเทคโนโลยีที่ทันสมัยและทีมงานมืออาชีพ
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
            <a
              href="#services"
              className="bg-white text-napa-blue-800 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              ดูบริการของเรา
            </a>
            <a
              href="#contact"
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-napa-blue-800 transition-all duration-300 transform hover:scale-105"
            >
              ติดต่อเรา
            </a>
          </div>

          {/* Stats */}
          <div className="mt-16 grid grid-cols-2 gap-6 max-w-lg mx-auto lg:mx-0">
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-blue-300/20">
              <div className="text-3xl font-bold text-white mb-2">500+</div>
              <div className="text-blue-200 text-sm">โครงการที่สำเร็จ</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-blue-300/20">
              <div className="text-3xl font-bold text-white mb-2">50+</div>
              <div className="text-blue-200 text-sm">พันธมิตร</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-blue-300/20">
              <div className="text-3xl font-bold text-white mb-2">10+</div>
              <div className="text-blue-200 text-sm">ปีประสบการณ์</div>
            </div>
            <div className="text-center bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-blue-300/20">
              <div className="text-3xl font-bold text-white mb-2">24/7</div>
              <div className="text-blue-200 text-sm">บริการสนับสนุน</div>
            </div>
          </div>
          </div>

          {/* Right Content - Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              {/* Image Container with Glass Frame */}
              <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 shadow-2xl">
                <div className="w-80 h-80 lg:w-96 lg:h-96 rounded-xl overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                    alt="Napa Corporation - Technology Solutions"
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
                
                {/* Floating Tech Icons around image */}
                <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white text-xl shadow-lg animate-bounce">
                  🛡️
                </div>
                <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-700 rounded-full flex items-center justify-center text-white text-xl shadow-lg animate-bounce delay-1000">
                  ⚡
                </div>
                <div className="absolute top-1/2 -right-6 w-10 h-10 bg-gradient-to-r from-blue-300 to-blue-500 rounded-full flex items-center justify-center text-white text-lg shadow-lg animate-bounce delay-500">
                  🌐
                </div>
                <div className="absolute top-1/4 -left-6 w-10 h-10 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white text-lg shadow-lg animate-bounce delay-1500">
                  💻
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute inset-0 -z-10 bg-gradient-to-r from-blue-400/20 to-blue-600/20 rounded-2xl blur-xl"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
